/* lk-lens.js — copy of the theme's ee-lens.js with two owner-requested changes
   (2026-09-10): a "Single vision tinted" package type, and it now runs on
   sunglasses as well as optical frames. Lens packages are variants of a separate
   product; the prescription travels as line-item properties. JS-off: the native
   form still adds the frame on its own. */

(function () {
'use strict';
var root = document.querySelector('[data-ee-lens]');
if (root) { try { selector(root); } catch (e) { if (window.console) console.warn('lk-lens', e); } }
function money(cents, fmt) {
var n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
return (fmt || 'Rs. {{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, n).replace(/<[^>]+>/g, '');
}
function num(v) {
if (v == null) return NaN;
v = String(v).trim().replace(/−/g, '-').replace(/,/g, '.').replace(/^\+/, '');
if (v === '' ) return NaN;
return Number(v);
}
function fmtD(v) { return (v > 0 ? '+' : v < 0 ? '−' : '') + Math.abs(v).toFixed(2); }
function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
function selector(root) {
var cfg = JSON.parse(root.querySelector('[data-ee-lens-config]').textContent);
var variants = cfg.variants.filter(function (v) { return v.available; });
if (!variants.length) return;
var form = document.querySelector('form[action*="/cart/add"]');
var addBtn = form && form.querySelector('.ee-add-button');
if (!form || !addBtn) return;
var drawer = root.querySelector('.eel-drawer');
var body = root.querySelector('[data-eel-body]');
var steps = { usage: root.querySelector('[data-eel-step="usage"]'), rx: root.querySelector('[data-eel-step="rx"]'), pkg: root.querySelector('[data-eel-step="package"]') };
var nextBtn = root.querySelector('[data-eel-next]');
var backBtn = root.querySelector('[data-eel-back]');
var summary = root.querySelector('[data-eel-summary]');
var stepLabel = root.querySelector('[data-eel-step-label]');
var errorEl = root.querySelector('[data-eel-error]');
var pkgWrap = root.querySelector('[data-eel-packages]');
var fileInput = root.querySelector('[data-eel-file]');
var fileName = root.querySelector('[data-eel-filename]');
var addRow = root.querySelector('[data-eel-add]');
var maxBytes = (Number(root.dataset.maxMb) || 10) * 1024 * 1024;
var wa = (root.dataset.whatsapp || '').replace(/\D/g, '');
var framePrice = Number(root.dataset.framePrice) || 0;
var minPrice = variants.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);
var note = el('p', 'eel-trigger-note', 'Prescription lenses from ' + money(minPrice, cfg.moneyFormat) + ' · or add the frame only.');
form.insertAdjacentElement('afterend', note);
var textNode = Array.prototype.find.call(addBtn.childNodes, function (n) { return n.nodeType === 3 && n.nodeValue.trim(); });
if (textNode) textNode.nodeValue = 'Choose lenses & add ';
addBtn.setAttribute('aria-haspopup', 'dialog');
var state = { usage: null, mode: 'enter', pkg: null, file: null, flow: ['usage'], at: 0, bypass: false };
form.addEventListener('submit', function (e) {
if (state.bypass) return;
e.preventDefault();
open();
});
root.querySelectorAll('input[name="eel-usage"]').forEach(function (r) {
r.addEventListener('change', function () {
state.usage = r.value;
state.flow = r.value === 'none' ? ['usage'] : r.value === 'plano' ? ['usage', 'pkg'] : ['usage', 'rx', 'pkg'];
if (addRow) addRow.hidden = r.value !== 'progressive';
nextBtn.disabled = false;
nextBtn.textContent = r.value === 'none' ? 'Add frame to bag' : 'Continue';
renderSummary();
});
});
root.querySelectorAll('[data-eel-mode]').forEach(function (t) {
t.addEventListener('click', function () {
state.mode = t.dataset.eelMode;
root.querySelectorAll('[data-eel-mode]').forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
root.querySelectorAll('[data-eel-pane]').forEach(function (p) { p.hidden = p.dataset.eelPane !== state.mode; });
showError('');
});
});
var laterCopy = root.querySelector('[data-eel-later-copy]');
if (laterCopy && wa) laterCopy.innerHTML = 'After checkout, send a photo of your prescription on WhatsApp to <b>+' + wa + '</b>. We message you first. Lenses are cut once we have it.';
var drop = root.querySelector('[data-eel-drop]');
function setFile(f) {
state.file = null; fileName.hidden = true;
if (!f) return;
if (f.size > maxBytes) { showError('That file is ' + (f.size / 1048576).toFixed(1) + ' MB. Please keep it under ' + Math.round(maxBytes / 1048576) + ' MB.'); fileInput.value = ''; return; }
if (!/^image\/|pdf$|heic|heif/i.test(f.type || '') && !/\.(jpe?g|png|webp|pdf|heic|heif)$/i.test(f.name)) { showError('Please upload a photo (JPG, PNG, HEIC) or a PDF.'); fileInput.value = ''; return; }
state.file = f;
fileName.textContent = '✓ ' + f.name + ' (' + (f.size / 1048576).toFixed(1) + ' MB)';
fileName.hidden = false;
showError('');
}
fileInput.addEventListener('change', function () { setFile(fileInput.files[0]); });
['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); if (ev === 'drop' && e.dataTransfer.files[0]) setFile(e.dataTransfer.files[0]); }); });
steps.rx.addEventListener('input', function (e) { if (e.target.matches('input')) { e.target.removeAttribute('aria-invalid'); showError(''); } });
root.querySelector('[name="pd_unknown"]').addEventListener('change', function (e) { root.querySelector('[name="pd"]').disabled = e.target.checked; });
nextBtn.addEventListener('click', function () {
var cur = state.flow[state.at];
if (cur === 'rx' && !validateRx()) return;
if (cur === 'pkg' && !state.pkg) { showError('Choose a lens package to continue.'); return; }
if (state.at === state.flow.length - 1) { submit(); return; }
state.at++;
show();
});
backBtn.addEventListener('click', function () { if (state.at > 0) { state.at--; show(); } });
root.querySelectorAll('[data-eel-close]').forEach(function (b) { b.addEventListener('click', close); });
drawer.addEventListener('keydown', function (e) {
if (e.key === 'Escape') { close(); return; }
if (e.key !== 'Tab') return;
var f = drawer.querySelectorAll('button:not([disabled]):not([hidden]), input:not([disabled]):not([type="radio"]):not([hidden]), input[type="radio"]:checked, [tabindex="0"]');
f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
if (!f.length) return;
var first = f[0], last = f[f.length - 1];
if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
var lastFocus = null;
function open() {
lastFocus = document.activeElement;
root.hidden = false;
document.body.classList.add('eel-lock');
requestAnimationFrame(function () { root.classList.add('is-open'); drawer.focus(); });
state.at = 0; show();
}
function close() {
root.classList.remove('is-open');
document.body.classList.remove('eel-lock');
var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
setTimeout(function () { root.hidden = true; if (lastFocus && lastFocus.focus) lastFocus.focus(); }, rm ? 0 : 320);
}
function show() {
var cur = state.flow[state.at];
steps.usage.hidden = cur !== 'usage';
steps.rx.hidden = cur !== 'rx';
steps.pkg.hidden = cur !== 'pkg';
backBtn.hidden = state.at === 0;
stepLabel.textContent = 'Step ' + (state.at + 1) + ' of ' + state.flow.length;
if (cur === 'pkg') renderPackages();
nextBtn.disabled = cur === 'usage' ? !state.usage : cur === 'pkg' ? !state.pkg : false;
nextBtn.textContent = state.at === state.flow.length - 1 ? (state.usage === 'none' ? 'Add frame to bag' : 'Add to bag') : 'Continue';
showError('');
body.scrollTop = 0;
renderSummary();
}
function showError(msg) { errorEl.textContent = msg; errorEl.hidden = !msg; }
function field(n) { return root.querySelector('[name="' + n + '"]'); }
function bad(n, msg) { var f = field(n); if (f) { f.setAttribute('aria-invalid', 'true'); if (!errorEl.textContent) f.focus(); } showError(msg); return false; }
function step25(v) { return Math.abs(v * 4 - Math.round(v * 4)) < 1e-6; }
function validateRx() {
if (state.mode === 'later') return true;
if (state.mode === 'upload') {
if (!state.file) return bad(null, 'Please choose a photo or PDF of your prescription, or switch to “Enter values”.');
var pdU = field('pd_upload').value.trim();
if (pdU && !pdOk(pdU)) return bad('pd_upload', 'PD is usually between 50 and 80 mm (or two numbers like 31/31).');
return true;
}
var eyes = ['od', 'os'];
for (var i = 0; i < eyes.length; i++) {
var e = eyes[i];
var sph = num(field(e + '_sph').value), cyl = field(e + '_cyl').value.trim() === '' ? 0 : num(field(e + '_cyl').value), axis = field(e + '_axis').value.trim();
if (isNaN(sph)) return bad(e + '_sph', 'Enter SPH for both eyes (use 0.00 if there is no power).');
if (sph < -20 || sph > 20 || !step25(sph)) return bad(e + '_sph', 'SPH goes from −20.00 to +20.00 in steps of 0.25.');
if (isNaN(cyl) || cyl < -6 || cyl > 6 || !step25(cyl)) return bad(e + '_cyl', 'CYL goes from −6.00 to +6.00 in steps of 0.25.');
if (cyl !== 0) {
var ax = num(axis);
if (isNaN(ax) || ax < 1 || ax > 180 || ax !== Math.round(ax)) return bad(e + '_axis', 'AXIS is a whole number from 1 to 180 — it is on the prescription next to CYL.');
}
}
if (state.usage === 'progressive') {
var add = num(field('add').value);
if (isNaN(add) || add < 0.75 || add > 3.5 || !step25(add)) return bad('add', 'ADD for progressives is usually +0.75 to +3.50.');
}
var pdUnknown = field('pd_unknown').checked, pd = field('pd').value.trim();
if (!pdUnknown && pd && !pdOk(pd)) return bad('pd', 'PD is usually between 50 and 80 mm (or two numbers like 31/31).');
return true;
}
function pdOk(v) {
var m = v.replace(/\s/g, '').match(/^(\d{2}(?:\.\d)?)(?:\/(\d{2}(?:\.\d)?))?$/);
if (!m) return false;
if (m[2]) return +m[1] >= 25 && +m[1] <= 40 && +m[2] >= 25 && +m[2] <= 40;
return +m[1] >= 50 && +m[1] <= 80;
}
function maxPower() {
if (state.mode !== 'enter') return 0;
var vals = ['od_sph', 'os_sph'].map(function (n) { return Math.abs(num(field(n).value) || 0); });
return Math.max.apply(null, vals);
}
function rxSummary() {
if (state.usage === 'plano' || state.usage === 'none') return {};
if (state.mode === 'later') return { 'Prescription': 'Will send on WhatsApp after checkout' };
if (state.mode === 'upload') { var o = { 'Prescription': state.file }; var p = field('pd_upload').value.trim(); if (p) o['PD'] = p + ' mm'; return o; }
var out = {};
['od', 'os'].forEach(function (e) {
var sph = num(field(e + '_sph').value), cyl = field(e + '_cyl').value.trim() === '' ? 0 : num(field(e + '_cyl').value), ax = field(e + '_axis').value.trim();
var s = 'SPH ' + fmtD(sph);
if (cyl) s += ' · CYL ' + fmtD(cyl) + ' · AXIS ' + ax;
out[e === 'od' ? 'Right eye (OD)' : 'Left eye (OS)'] = s;
});
if (state.usage === 'progressive') out['ADD'] = fmtD(num(field('add').value));
out['PD'] = field('pd_unknown').checked ? 'Not sure — please help me measure' : (field('pd').value.trim() ? field('pd').value.trim() + ' mm' : 'Not given');
out['Prescription'] = 'Entered on the website';
return out;
}
var DESC = {
'Single vision': 'Clear lenses with anti-glare, scratch-resistant and UV400.',
'Single vision tinted': 'Tinted single-vision lens for sunglasses. UV400, anti-glare, scratch-resistant.',
'Single vision blue-light': 'Adds a blue-light filter for screens.',
'Progressive': 'Distance to reading in one lens, no visible line.',
'Photochromic': 'Clear indoors, darkens in sunlight.',
'Zero power blue-light': 'No prescription. Blue-light filter for screens.'
};
var TYPES = { 'sv-distance': ['Single vision', 'Single vision tinted', 'Single vision blue-light', 'Photochromic'], 'sv-reading': ['Single vision', 'Single vision tinted', 'Single vision blue-light', 'Photochromic'], 'progressive': ['Progressive'], 'plano': ['Zero power blue-light'] };
function recommendedIndex() { var p = maxPower(); return p > 4 ? '1.67' : p > 2 ? '1.61' : '1.56'; }
function renderPackages() {
var allowed = TYPES[state.usage] || [];
var list = variants.filter(function (v) { return allowed.indexOf(v.type) >= 0; }).sort(function (a, b) { return allowed.indexOf(a.type) - allowed.indexOf(b.type) || a.price - b.price; });
var rec = recommendedIndex();
pkgWrap.innerHTML = '';
if (state.pkg && list.indexOf(state.pkg) < 0) state.pkg = null;
var hi = maxPower() > 8;
root.querySelector('[data-eel-package-lead]').textContent = hi ? 'Your power is above ±8.00 — choose a package and we will confirm the best lens with you before cutting.' : 'Every package includes anti-glare, scratch-resistant and UV400 coatings.';
list.forEach(function (v, i) {
var isRec = v.index === rec && (v.type === 'Single vision' || v.type === 'Progressive' || v.type === 'Zero power blue-light');
var lab = el('label', 'eel-choice');
lab.innerHTML = '<input type="radio" name="eel-pkg" value="' + v.id + '"><span><b>' + v.type + ' · ' + v.index + (isRec ? '<span class="eel-badge">Recommended</span>' : '') + '</b><small>' + (DESC[v.type] || '') + (v.index === '1.61' ? ' Thinner, lighter lens.' : v.index === '1.67' ? ' Thinnest lens for strong powers.' : '') + '</small></span><span class="eel-price">' + money(v.price, cfg.moneyFormat) + '</span>';
var inp = lab.querySelector('input');
inp.checked = state.pkg === v;
inp.addEventListener('change', function () { state.pkg = v; nextBtn.disabled = false; showError(''); renderSummary(); });
pkgWrap.appendChild(lab);
});
}
function renderSummary() {
var lines = [['Frame', money(framePrice, cfg.moneyFormat)]];
if (state.usage === 'none') lines.push(['Lenses', 'None']);
else if (state.pkg) lines.push(['Lenses · ' + state.pkg.type + ' ' + state.pkg.index, money(state.pkg.price, cfg.moneyFormat)]);
else if (state.usage) lines.push(['Lenses', 'from ' + money(minPrice, cfg.moneyFormat)]);
var total = framePrice + (state.usage === 'none' ? 0 : state.pkg ? state.pkg.price : 0);
var dl = '<dl>' + lines.map(function (l) { return '<dt>' + l[0] + '</dt><dd>' + l[1] + '</dd>'; }).join('') + '<dt class="eel-total">Total</dt><dd class="eel-total">' + money(total, cfg.moneyFormat) + (state.usage && state.usage !== 'none' && !state.pkg ? '+' : '') + '</dd></dl>';
summary.innerHTML = dl;
}
function submit() {
var qty = Math.max(1, parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10));
var frameId = form.querySelector('[name="id"]').value;
var frameTitle = root.dataset.frameTitle;
var bundle = 'ee-' + Date.now().toString(36);
nextBtn.disabled = true; nextBtn.classList.add('is-busy'); showError('');
var lensKey = null;
var p = Promise.resolve();
if (state.usage !== 'none') {
p = p.then(function () {
var fd = new FormData();
fd.append('id', state.pkg.id);
fd.append('quantity', qty);
fd.append('properties[Frame]', frameTitle);
fd.append('properties[Lens type]', state.pkg.type);
fd.append('properties[Index]', state.pkg.index);
fd.append('properties[Use]', ({ 'sv-distance': 'Single vision · distance', 'sv-reading': 'Single vision · reading', 'progressive': 'Progressive', 'plano': 'Zero power' })[state.usage]);
var rx = rxSummary();
Object.keys(rx).forEach(function (k) { if (rx[k] instanceof File) fd.append('properties[' + k + ']', rx[k], rx[k].name); else fd.append('properties[' + k + ']', rx[k]); });
fd.append('properties[_bundle]', bundle);
return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add the lenses.'); lensKey = j.key; }); });
});
}
p = p.then(function () {
var props = { 'Lenses': state.usage === 'none' ? 'Frame only — no lenses' : state.pkg.type + ' · ' + state.pkg.index, '_bundle': bundle };
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(frameId), quantity: qty, properties: props }] }) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add the frame.'); }); });
}).then(function () {
window.location.href = '/cart';
}).catch(function (err) {
var msg = (err && err.message) || 'Something went wrong. Please try again.';
var done = function () { nextBtn.disabled = false; nextBtn.classList.remove('is-busy'); showError(msg); };
if (lensKey) fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lensKey, quantity: 0 }) }).then(done, done); else done();
});
}
}
})()
